<div class="mission-page">

  <!-- Header -->
  <div class="page-header">
    <h2 class="page-title">المأموريات</h2>
    <dx-button
      text="إضافة مأمورية"
      icon="plus"
      type="Add"
      stylingMode="contained"
      (onClick)="goToAdd()">
    </dx-button>
  </div>

  <!-- DataGrid -->
  <dx-data-grid
    [dataSource]="missions"
    [showBorders]="true"
    [showRowLines]="true"
    [columnAutoWidth]="true"
    [rowAlternationEnabled]="true"
    [rtlEnabled]="true"
    [loadPanel]="{ enabled: loading }">

    <dxo-search-panel [visible]="true" placeholder="بحث..."></dxo-search-panel>
    <dxo-paging [pageSize]="10"></dxo-paging>
    <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 20, 50]"></dxo-pager>
    <dxo-export [enabled]="true" fileName="missions"></dxo-export>

    <dxi-column dataField="id" caption="الكود" [width]="70"></dxi-column>
    <dxi-column dataField="employeeName" caption="الموظف"></dxi-column>
    <dxi-column dataField="name" caption="اسم المأمورية"></dxi-column>
    <dxi-column dataField="missionLocation" caption="الموقع"></dxi-column>

    <dxi-column dataField="missionType" caption="النوع" [width]="100">
      <dxo-lookup
         [dataSource]="missionTypes"
              valueExpr="id"
       displayExpr="nameAr">
      </dxo-lookup>
    </dxi-column>

    <dxi-column dataField="missionStatus" caption="الحالة" [width]="110" cellTemplate="statusTemplate">
    </dxi-column>
    <div *dxTemplate="let cell of 'statusTemplate'">
      <dx-button
        [text]="getMissionStatusText(cell.value)"
        [type]="getMissionStatusColor(cell.value)"
        stylingMode="outlined"
        [disabled]="true">
      </dx-button>
    </div>

    <dxi-column dataField="visitStartTime" caption="بداية الزيارة" dataType="datetime" format="dd/MM/yyyy HH:mm"></dxi-column>
    <dxi-column dataField="visitEndTime" caption="نهاية الزيارة" dataType="datetime" format="dd/MM/yyyy HH:mm"></dxi-column>
    <dxi-column dataField="dayCount" caption="عدد الأيام" [width]="90"></dxi-column>

    <dxi-column dataField="totalMissionCost" caption="إجمالي التكلفة" [width]="120" dataType="number" format="#,##0.00"></dxi-column>
    <dxi-column dataField="collectedAmountFromClient" caption="المحصل" [width]="100" dataType="number" format="#,##0.00"></dxi-column>
    <dxi-column dataField="netMissionCost" caption="الصافي" [width]="100" cellTemplate="netTemplate"></dxi-column>
    <div *dxTemplate="let cell of 'netTemplate'">
      <span [style.color]="cell.value < 0 ? '#e74c3c' : '#27ae60'" style="font-weight:bold">
        {{ cell.value | number:'1.2-2' }}
      </span>
    </div>

    <dxi-column caption="إجراءات" [width]="150" cellTemplate="actionsTemplate" [allowSorting]="false"></dxi-column>
    <div *dxTemplate="let cell of 'actionsTemplate'">
      <dx-button
        icon="info"
        hint="التفاصيل المالية"
        stylingMode="text"
        type="default"
        (onClick)="showFinancialDetails(cell.data)">
      </dx-button>
      <dx-button
        icon="edit"
        hint="تعديل"
        stylingMode="text"
        type="default"
        (onClick)="goToEdit(cell.data.id)">
      </dx-button>
      <dx-button
        icon="trash"
        hint="حذف"
        stylingMode="text"
        type="danger"
        (onClick)="deleteMission(cell.data.id)">
      </dx-button>
    </div>

  </dx-data-grid>
</div>

<!-- Popup التفاصيل المالية -->
<dx-popup
  [(visible)]="financialPopupVisible"
  [width]="500"
  [height]="'auto'"
  title="التفاصيل المالية للمأمورية"
  [rtlEnabled]="true"
  [showCloseButton]="true">
  <div *dxTemplate="let data of 'content'">
    <div *ngIf="selectedMission" class="financial-details">

      <!-- المواصلات -->
      <div class="section-title"> المواصلات</div>
      <dx-data-grid
        [dataSource]="selectedMission.transportations"
        [showBorders]="true"
        [rtlEnabled]="true"
        [columnAutoWidth]="true">
        <dxi-column dataField="order" caption="#" [width]="40"></dxi-column>
        <dxi-column dataField="fromDestination" caption="من"></dxi-column>
        <dxi-column dataField="toDestination" caption="إلى"></dxi-column>
        <dxi-column dataField="cost" caption="التكلفة" format="#,##0.00"></dxi-column>
      </dx-data-grid>

      <!-- التكاليف الأخرى -->
      <div class="section-title" style="margin-top:16px"> تكاليف أخرى</div>
      <dx-data-grid
        [dataSource]="selectedMission.expenses"
        [showBorders]="true"
        [rtlEnabled]="true"
        [columnAutoWidth]="true">
        <dxi-column dataField="description" caption="البيان"></dxi-column>
        <dxi-column dataField="amount" caption="المبلغ" format="#,##0.00"></dxi-column>
      </dx-data-grid>

      <!-- ملخص مالي -->
      <div class="financial-summary">
        <div class="summary-row">
          <span>إجمالي المواصلات</span>
          <span>{{ selectedMission.transportationCost | number:'1.2-2' }}</span>
        </div>
        <div class="summary-row">
          <span>إجمالي تكاليف أخرى</span>
          <span>{{ selectedMission.otherExpensesTotal | number:'1.2-2' }}</span>
        </div>
        <div class="summary-row total">
          <span>إجمالي التكلفة</span>
          <span>{{ selectedMission.totalMissionCost | number:'1.2-2' }}</span>
        </div>
        <div class="summary-row collected" *ngIf="selectedMission.isCollectedFromClient">
          <span>التحصيل من العميل ({{ selectedMission.collectionReason }})</span>
          <span>{{ selectedMission.collectedAmountFromClient | number:'1.2-2' }}</span>
        </div>
        <div class="summary-row net" [class.negative]="selectedMission.netMissionCost < 0">
          <span>{{ selectedMission.netMissionCost < 0 ? '⚠️ الموظف مدين للشركة' : '✅ مستحق للموظف' }}</span>
          <span>{{ (selectedMission.netMissionCost < 0 ? selectedMission.amountEmployeeOwes : selectedMission.amountCompanyOwes) | number:'1.2-2' }}</span>
        </div>
      </div>

    </div>
  </div>
</dx-popup>
